module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-1556-retro-min.711e8899.jpg";